// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button } from '@mui/material'
import React from 'react'
import RestrictedView from '../../auth/RestrictedView'
import withUser from '../../auth/withUser'
import { i18n } from '../../index'
import { ThumbableService } from '../thumbableService/thumbableServiceTypes'
import ChecklistDialog from './ChecklistDialog'
import css from './checklistPage.css'
import ChecklistTable from './ChecklistTable'
import type { ChecklistItem } from './checklistTypes'

type ChecklistPageProps = {
  data: Array<ThumbableService>
  stationId?: string
}

type ChecklistPageState = {
  isDialogOpen: boolean
  data: ChecklistItem | null | undefined
}

@withUser
class ChecklistPage extends React.Component<ChecklistPageProps, ChecklistPageState> {
  state = {
    isDialogOpen: false,
    data: null,
  }

  openDialog = () => {
    this.setState({ isDialogOpen: true })
  }

  closeDialog = () => {
    this.setState({ isDialogOpen: false, data: null })
  }

  onEdit = (data: ChecklistItem) => {
    this.setState({ data })
    this.openDialog()
  }

  render() {
    const { data: checklistItems, stationId, refetch } = this.props
    const { isDialogOpen, data } = this.state

    return (
      <div className={css.component}>
        <ChecklistTable data={checklistItems} stationId={stationId} onEdit={this.onEdit} refetch={refetch} />
        <div className={css.bottom}>
          <RestrictedView requiredPermission='manage_ownStation'>
            <Button onClick={this.openDialog} variant='contained' color='primary'>
              {i18n.t('buttons.create')}
            </Button>
          </RestrictedView>
        </div>
        <ChecklistDialog
          data={data}
          stationId={stationId}
          isOpen={isDialogOpen}
          onClose={this.closeDialog}
          refetch={refetch}
        />
      </div>
    )
  }
}

export default ChecklistPage
